// this file gets imports LogRocket from node_modules for web builds -
// the kiosk version imports the minified LogRocket code from within the codebase
// to avoid Chrome app permissions errors
export const getLogRocketImports = () => ({
  logrocket: import('logrocket'),
  logrocketFuzzySanitizer: import('logrocket-fuzzy-search-sanitizer')
});
